var langSelectEn = document.getElementById("langEn");
var langSelectFr = document.getElementById("langFr");
var langSelectEs = document.getElementById("langEs");
langSelectEn.addEventListener("click", function (e) {
  document.cookie = "pf-accept-language=en; path=/";
  window.location.reload();
});
langSelectFr.addEventListener("click", function (e) {
  document.cookie = "pf-accept-language=fr-CA; path=/";
  window.location.reload();
});
langSelectEs.addEventListener("click", function (e) {
  document.cookie = "pf-accept-language=es; path=/";
  window.location.reload();
});